export { SkillGiftWrapping as default } from './SkillGiftWrapping';
